import { LambdaProcessEnv } from "../../common"
import { ILambdaLogger, LambdaLogLevel, LogLevel, StdLogOutput } from "../../Logging"

const debug = false
/** used in unit test to replace logger, so developers can get output to console without changing code */

const { AWS_LAMBDA_FUNCTION_NAME } = process.env as LambdaProcessEnv
const functionName = AWS_LAMBDA_FUNCTION_NAME || 'mock'

export class ProxyLogger implements ILambdaLogger {
    /** constructor for the proxy logger
     * @param logAtLevel - the level at which to log messages
     * @param useTimestampPrefix - whether to use a timestamp prefix in the log message (for cloudwatch output from ECS)
     */
    constructor(logAtLevel: LogLevel = LogLevel.ERROR, useTimestampPrefix = true) {
        debug && console.log( `Setting proxy logger level to`, logAtLevel )
        this._logAtLevel = logAtLevel
        this.useTimestampPrefix = useTimestampPrefix ?? false
        this._logSpecial = true
    }
    _logAtLevel: LogLevel
    useTimestampPrefix: boolean
    messages: StdLogOutput<LambdaLogLevel>[] = []
    // allows special logging, default true, provided not imported as ILambdaLogger, may be used to toggle investigative logging 
    _logSpecial: boolean

  set logAtLevel(logLevel: LogLevel) {
    debug && console.log(`ProxyLogger got set logAtLevel ${logLevel}`)
    this._logAtLevel = logLevel
  }

  get logAtLevel(): LogLevel {
    return this._logAtLevel
  }
 /** allows special logging, default true, provided not imported as ILambdaLogger, may be used to toggle investigative logging */
  set logSpecial( onOff: boolean ) {
    this._logSpecial = onOff
  }

  flush = async () => {}

    proxyLogAtLevelFn = <LL extends LambdaLogLevel>( logLevel: LL ): (...msg: any[]) => StdLogOutput<LL> => ( ...args: any[] )=> {
        const now = new Date()
        const res: StdLogOutput<LL> = {
            functionName, level: logLevel, message: args, timestamp: now.valueOf(),
        };
        const logEntryPrefix = this.useTimestampPrefix ? `${ now.toISOString() } ` : ''
        const logAtLevelIdx = LogLevel[ logLevel ]
        debug && console.log(`ProxyLogger with setting ${ LogLevel[this.logAtLevel] } (${ this.logAtLevel}) got message with level ${ LogLevel[logAtLevelIdx ] } (${ logAtLevelIdx })`)
        if ( logAtLevelIdx >= this.logAtLevel  ) {
            console.log(`${ logEntryPrefix }ProxyLogger ${ logLevel }:`, ...args )
         } else {
            debug && console.log(`ProxyLogger ${ logLevel } not logged because ${ logAtLevelIdx } < ${ LogLevel[this.logAtLevel] }`)
         }

    
      return res
    }

   

    debug = this.proxyLogAtLevelFn( 'DEBUG' )
    trace = this.proxyLogAtLevelFn( 'TRACE' )
    info = this.proxyLogAtLevelFn( 'INFO' )
    warn = this.proxyLogAtLevelFn( 'WARN' )
    error = this.proxyLogAtLevelFn( 'ERROR' )
    fatal = this.proxyLogAtLevelFn( 'FATAL')

    // provisionally a function that allows specific messages to be logged outside of LOG_AT_LEVEL
    special = ( ...args: any[]) => this._logSpecial && console.log(`ProxyLogger SPECIAL:`, ...args )

}

export const proxyLogger = new ProxyLogger(LogLevel.DEBUG)
